import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // Ported from the pre-migration src/App.tsx QueryClient instantiation.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        staleTime: 30_000,
        // Long gcTime: keeps page data warm for fast back/forward navigation.
        gcTime: 30 * 60_000,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  // Exposed so non-React helpers (e.g. the quota interceptor) can navigate
  // through the router instead of pushState + popstate, which desyncs
  // TanStack Router and can blank the screen.
  if (typeof window !== "undefined") {
    (window as any).__appRouter = router;
  }

  return router;
};

